import React, { useContext } from "react";
import { CTABox } from "../../components/CTABox/CTABox";
import { Col, Row } from "react-bootstrap";
import { InstallationContext } from "../../contexts/InstallationContext";
import { AOS_ANIMATION, AOS_DELAY } from "../../config";
import { HTMLParser } from "../HTMLParser/HTMLParser";

interface InstallationCTAsProps {}

export const InstallationCTAs: React.FC<InstallationCTAsProps> = () => {
  const installationContext = useContext(InstallationContext);
  const installation = installationContext.installationItems[0];

  if (installation)
    return (
      <Row md={3} xs={1}>
        {installation.install_link_article_1 &&
          installation.install_button_text_1 && (
            <Col>
              <CTABox
                target={`/article/${installation.install_link_article_1}`}
                dataAos={AOS_ANIMATION}
              >
                <HTMLParser html={installation.install_button_text_1} />
              </CTABox>
            </Col>
          )}
        {installation.install_article_link_2 &&
          installation.install_button_text_2 && (
            <Col>
              <CTABox
                target={`/article/${installation.install_article_link_2}`}
                dataAos={AOS_ANIMATION}
                dataAosDelay={1 * AOS_DELAY}
              >
                <HTMLParser html={installation.install_button_text_2} />
              </CTABox>
            </Col>
          )}
        {installation.install_link_article_3 &&
          installation.install_button_text_3 && (
            <Col>
              <CTABox
                target={`/article/${installation.install_link_article_3}`}
                dataAos={AOS_ANIMATION}
                dataAosDelay={2 * AOS_DELAY}
              >
                <HTMLParser html={installation.install_button_text_3} /> 
              </CTABox>
            </Col>
          )}
      </Row>
    );

  return <></>;
};
